import { arcgisToGeoJSON } from "@esri/arcgis-to-geojson-utils";
import { get, writable } from "svelte/store";
import LoadState from "../Enums/LoadState";
import GeoHelper from "../Helpers/GeoHelper";
import MapLayerGroup from "../Map/Enums/MapLayerGroup";
import VisibilityState from "../Map/Enums/VisibilityState";
import MapLayerManager from "../Map/MapLayerManager";
import { Paint } from "../Map/MapLayerStyles";
import PopupStore from "../Map/Popup/PopupStore";
import MapStore from "../Map/Store";
import ESRIClassStore from "../Stores/ESRIClassStore";

// TODO: this func is same in UKHOcharts store
const initLayerData = () => {
	return {
		layers: [],
		loadState: writable(LoadState.INIT),
		visible: writable(false)
	};
};
const UKHOWindStore = {
	config: {
		server: "https://services1.arcgis.com/ZURaVO35aTK1Ugmq/arcgis/rest/services",

		cables: "/UKHO_Wind_Farm_Cables/FeatureServer", 		 				// Lines
		structures: "/UKHO_Wind_Farm_Surface_Structures/FeatureServer",			// Points
		oag_surfaces: "/UKHO_Floating_Oil_and_Gas_Surface_Installations/FeatureServer/", // Points
		oag_platforms: "/UKHO_Platforms/FeatureServer"
	},
	meta: {
		loadState: writable(LoadState.INIT),
		layers: [],
		layerData: {
			ukho_cables: initLayerData(),
			ukho_structures: initLayerData(),
			ukho_oag_surfaces: initLayerData(),
			ukho_oag_platforms: initLayerData()
		},
		visible: writable(false),
		esri: {
			objects: {
				layers: {
					cables: null,
					structures: null,
					oag_surfaces: null,
					oag_platforms: null
				}
			}
		},
		lastUpdated: writable(0)
	},
	results: {
		cables: writable([]),
		structures: writable([]),
		oag_surfaces: writable([]),
		oag_platforms: writable([])
	},
	filters: {
		filterString: writable("")
	},
	actions: {
		loadWindCables: () => {
			UKHOWindStore.meta.layerData.ukho_cables.loadState.set(LoadState.LOADING);

			const FeatureLayer = ESRIClassStore.classes.FeatureLayer.classPrototype;
			const Query = ESRIClassStore.classes.Query.classPrototype;

			const cablesUrl = UKHOWindStore.config.server + UKHOWindStore.config.cables;
			const cablesLayer = new FeatureLayer({ url: cablesUrl, layerId: 0 });
			UKHOWindStore.meta.esri.objects.layers.cables = cablesLayer;

			const queryCables = new Query();
			queryCables.returnGeometry = true;
			queryCables.where = "1 = 1";
			queryCables.outFields = ["FID", "CATCBL", "STATUS", "site_name"];
			queryCables.geometryPrecision = 4;
			queryCables.num = 200;

			Promise.all([
				cablesLayer.queryFeatures(queryCables)
			]).then((responses) => {
				const cables = [];
				const cablesResponse = responses[0];
				for (let i = 0; i < cablesResponse.features.length; i++) {
					const feature = arcgisToGeoJSON(cablesResponse.features[i]);
					cables.push(feature);
				}
				UKHOWindStore.helpers._addDataLayer("ukho_cables", "line", Paint.measure.lines, GeoHelper.emptyGeoJson());
				UKHOWindStore.meta.layerData.ukho_cables.layers.push("ukho_cables");

				const onEnterPointCable = (e) => {
					UKHOWindStore.helpers.onEnterPointShow(e, {
						Name: "site_name",
						Category: "CATCBL",
						Status: "STATUS"
					});
				};
				const map = MapStore.helpers.getMap();
				map.on("mouseenter", UKHOWindStore.meta.layerData.ukho_cables.layers[0], onEnterPointCable);
				map.on("mouseleave", UKHOWindStore.meta.layerData.ukho_cables.layers[0], UKHOWindStore.helpers.onLeavePoint);

				UKHOWindStore.results.cables.set(cables);
				UKHOWindStore.meta.layerData.ukho_cables.loadState.set(LoadState.LOADED);
				UKHOWindStore.meta.lastUpdated.set(Date.now());

				const loadedLayers = UKHOWindStore.helpers.getLoadedLayers();
				MapLayerManager.addLayerGroup(MapLayerGroup.OFFSHORE_INFRASTRUCTURE, loadedLayers, loadedLayers);
				MapLayerManager.reorderLayerGroups();
			});
		},
		loadWindStructures: () => {
			UKHOWindStore.meta.layerData.ukho_structures.loadState.set(LoadState.LOADING);

			const FeatureLayer = ESRIClassStore.classes.FeatureLayer.classPrototype;
			const Query = ESRIClassStore.classes.Query.classPrototype;

			const structuresUrl = UKHOWindStore.config.server + UKHOWindStore.config.structures;
			const structuresLayer = new FeatureLayer({ url: structuresUrl, layerId: 1 });
			UKHOWindStore.meta.esri.objects.layers.structures = structuresLayer;

			const queryStructures = new Query();
			queryStructures.returnGeometry = true;
			queryStructures.where = "1 = 1";
			queryStructures.outFields = ["FID", "fldnme", "naclle", "strtyp", "instat", "maxhgt", "featid"];
			queryStructures.geometryPrecision = 4;

			Promise.all([
				structuresLayer.queryFeatures(queryStructures)
			]).then((responses) => {
				const structures = [];
				const structuresResponse = responses[0];
				for (let i = 0; i < structuresResponse.features.length; i++) {
					const feature = arcgisToGeoJSON(structuresResponse.features[i]);
					structures.push(feature);
				}
				UKHOWindStore.helpers._addDataLayer("ukho_structures", "circle", Paint.ukho.windTurbines, GeoHelper.emptyGeoJson());
				UKHOWindStore.meta.layerData.ukho_structures.layers.push("ukho_structures");

				const onEnterPointStructure = (e) => {
					UKHOWindStore.helpers.onEnterPointShow(e, {
						Name: "fldnme",
						Type: "strtyp",
						Status: "instat",
						ID: "featid"
					});
				};
				const map = MapStore.helpers.getMap();
				map.on("mouseenter", UKHOWindStore.meta.layerData.ukho_structures.layers[0], onEnterPointStructure);
				map.on("mouseleave", UKHOWindStore.meta.layerData.ukho_structures.layers[0], UKHOWindStore.helpers.onLeavePoint);

				UKHOWindStore.results.structures.set(structures);
				UKHOWindStore.meta.layerData.ukho_structures.loadState.set(LoadState.LOADED);
				UKHOWindStore.meta.lastUpdated.set(Date.now());

				const loadedLayers = UKHOWindStore.helpers.getLoadedLayers();
				MapLayerManager.addLayerGroup(MapLayerGroup.OFFSHORE_INFRASTRUCTURE, loadedLayers, loadedLayers);
				MapLayerManager.reorderLayerGroups();
			});
		},
		loadOAGSurfaces: () => {
			UKHOWindStore.meta.layerData.ukho_oag_surfaces.loadState.set(LoadState.LOADING);

			const FeatureLayer = ESRIClassStore.classes.FeatureLayer.classPrototype;
			const Query = ESRIClassStore.classes.Query.classPrototype;

			const oagSurfacesUrl = UKHOWindStore.config.server + UKHOWindStore.config.oag_surfaces;
			const oagSurfacesLayer = new FeatureLayer({ url: oagSurfacesUrl, layerId: 3 });
			UKHOWindStore.meta.esri.objects.layers.oag_surfaces = oagSurfacesLayer;

			const queryOAGSurfaces = new Query();
			queryOAGSurfaces.returnGeometry = true;
			queryOAGSurfaces.where = "1 = 1";
			queryOAGSurfaces.outFields = ["FID", "featid", "fldnme", "ogflty", "opertr", "instat"];
			queryOAGSurfaces.geometryPrecision = 4;

			Promise.all([
				oagSurfacesLayer.queryFeatures(queryOAGSurfaces)
			]).then((responses) => {
				const surfaces = [];
				const surfacesResponse = responses[0];
				for (let i = 0; i < surfacesResponse.features.length; i++) {
					const feature = arcgisToGeoJSON(surfacesResponse.features[i]);
					surfaces.push(feature);
				}
				UKHOWindStore.helpers._addDataLayer("ukho_oag_surfaces", "circle", Paint.ukho.oagSurfaces, GeoHelper.emptyGeoJson());
				UKHOWindStore.meta.layerData.ukho_oag_surfaces.layers.push("ukho_oag_surfaces");

				const onEnterPointStructure = (e) => {
					UKHOWindStore.helpers.onEnterPointShow(e, {
						Name: "featid",
						"Second Name": "fldnme",
						Type: "ogflty",
						Operator: "opertr",
						Status: "instat"
					});
				};
				const map = MapStore.helpers.getMap();
				map.on("mouseenter", UKHOWindStore.meta.layerData.ukho_oag_surfaces.layers[0], onEnterPointStructure);
				map.on("mouseleave", UKHOWindStore.meta.layerData.ukho_oag_surfaces.layers[0], UKHOWindStore.helpers.onLeavePoint);

				UKHOWindStore.results.oag_surfaces.set(surfaces);
				UKHOWindStore.meta.layerData.ukho_oag_surfaces.loadState.set(LoadState.LOADED);

				UKHOWindStore.meta.lastUpdated.set(Date.now());

				const loadedLayers = UKHOWindStore.helpers.getLoadedLayers();
				MapLayerManager.addLayerGroup(MapLayerGroup.OFFSHORE_INFRASTRUCTURE, loadedLayers, loadedLayers);
				MapLayerManager.reorderLayerGroups();
			});
		},
		loadOAGPlatforms: () => {
			UKHOWindStore.meta.layerData.ukho_oag_platforms.loadState.set(LoadState.LOADING);

			const FeatureLayer = ESRIClassStore.classes.FeatureLayer.classPrototype;
			const Query = ESRIClassStore.classes.Query.classPrototype;

			const oagPlatformsUrl = UKHOWindStore.config.server + UKHOWindStore.config.oag_platforms;
			const oagPlatformsLayer = new FeatureLayer({ url: oagPlatformsUrl, layerId: 4 });
			UKHOWindStore.meta.esri.objects.layers.oag_platforms = oagPlatformsLayer;

			const queryOAGPlatforms = new Query();
			queryOAGPlatforms.returnGeometry = true;
			queryOAGPlatforms.where = "1 = 1";
			queryOAGPlatforms.outFields = [
				"featid", "fldnme", "ogfsty", "opertr", "instat"
			];
			queryOAGPlatforms.geometryPrecision = 4;

			// featid	20/6a Buzzard Production Sweetening Platform / Small Steel
			// fldnme	BUZZARD
			// htheli	0.00
			// maxhgt	0.00
			// ogfsty	Unspecified
			// opertr	NEXEN PETROLEUM UK LTD
			// instat	Live

			Promise.all([
				oagPlatformsLayer.queryFeatures(queryOAGPlatforms)
			]).then((responses) => {
				const platforms = [];
				const platformsResponse = responses[0];
				for (let i = 0; i < platformsResponse.features.length; i++) {
					const feature = arcgisToGeoJSON(platformsResponse.features[i]);
					platforms.push(feature);
				}
				UKHOWindStore.helpers._addDataLayer("ukho_oag_platforms", "circle", Paint.ukho.oagPlatforms, GeoHelper.emptyGeoJson());
				UKHOWindStore.meta.layerData.ukho_oag_platforms.layers.push("ukho_oag_platforms");

				const onEnterPointStructure = (e) => {
					UKHOWindStore.helpers.onEnterPointShow(e, {
						Name: "featid",
						"Second Name": "fldnme",
						Type: "ogfsty",
						Operator: "opertr",
						Status: "instat"
					});
				};
				const map = MapStore.helpers.getMap();
				map.on("mouseenter", UKHOWindStore.meta.layerData.ukho_oag_platforms.layers[0], onEnterPointStructure);
				map.on("mouseleave", UKHOWindStore.meta.layerData.ukho_oag_platforms.layers[0], UKHOWindStore.helpers.onLeavePoint);

				UKHOWindStore.results.oag_platforms.set(platforms);
				UKHOWindStore.meta.layerData.ukho_oag_platforms.loadState.set(LoadState.LOADED);
				UKHOWindStore.meta.lastUpdated.set(Date.now());

				const loadedLayers = UKHOWindStore.helpers.getLoadedLayers();
				MapLayerManager.addLayerGroup(MapLayerGroup.OFFSHORE_INFRASTRUCTURE, loadedLayers, loadedLayers);
				MapLayerManager.reorderLayerGroups();
			});
		},
		init: () => {
			if (get(UKHOWindStore.meta.loadState) !== LoadState.INIT) {
				return;
			}
			UKHOWindStore.meta.loadState.set(LoadState.LOADING);
			console.log("Loading UKHO...");

			ESRIClassStore.actions.load()
				.then((classes) => {
					console.log("Loaded UKHO...");
					UKHOWindStore.meta.loadState.set(LoadState.LOADED);
					UKHOWindStore.meta.lastUpdated.set(Date.now());
				});
		},

		updateVisibility: () => {
			const map = MapStore.helpers.getMap();
			if (map) {
				if (get(UKHOWindStore.meta.loadState) !== LoadState.LOADED) {
					return;
				}
				const visible = get(UKHOWindStore.meta.visible);
				const dataLayers = Object.keys(UKHOWindStore.meta.layerData);
				for (let i = 0; i < dataLayers.length; i++) {
					const layer = UKHOWindStore.meta.layerData[dataLayers[i]];
					for (let j = 0; j < layer.layers.length; j++) {
						const layerVisible = get(layer.visible);
						map.setLayoutProperty(layer.layers[j], "visibility", (visible && layerVisible) ? VisibilityState.VISIBLE : VisibilityState.NONE);
					}
				}
			}
		},
		updateFeatureCollection: () => {
			const featureCollections = {
				cables: GeoHelper.emptyGeoJson(),
				structures: GeoHelper.emptyGeoJson()
			};
			const cables = get(UKHOWindStore.results.cables);
			for (let i = 0; i < cables.length; i++) {
				featureCollections.cables.features.push(cables[i]);
			}
			const structures = get(UKHOWindStore.results.structures);
			for (let i = 0; i < structures.length; i++) {
				featureCollections.structures.features.push(structures[i]);
			}
			const map = MapStore.helpers.getMap();
			if (map) {
				const source = map.getSource("ukho_cables");
				if (source) {
					source.setData(featureCollections.cables);
				}
				const source2 = map.getSource("ukho_structures");
				if (source2) {
					source2.setData(featureCollections.structures);
				}

				const source3 = map.getSource("ukho_oag_surfaces");
				if (source3) {
					source3.setData(GeoHelper.emptyGeoJson(get(UKHOWindStore.results.oag_surfaces)));
				}

				const source4 = map.getSource("ukho_oag_platforms");
				if (source4) {
					source4.setData(GeoHelper.emptyGeoJson(get(UKHOWindStore.results.oag_platforms)));
				}
			}
		}
	},
	helpers: {
		// TODO: consider moving to a map helper.
		_addDataLayer: (name, type, paint, featureCollection, addToArray = null) => {
			if (addToArray == null) {
				addToArray = UKHOWindStore.meta.layers;
			}
			const map = MapStore.helpers.getMap();
			map.addSource(name, {
				type: "geojson",
				data: featureCollection
			});
			map.addLayer(
				{
					id: name,
					type: type,
					source: name,
					paint: paint
				},
				"waterway-label" // MapLayer.VESSELS_NEARBY_LINES
			);
			addToArray.push(name);
		},
		onEnterPointShow: (e, map) => {
			if (e.features.length > 0) {
				// console.log("e", e);
				const props = {};
				const keys = Object.keys(map);
				for (let i = 0; i < keys.length; i++) {
					props[keys[i]] = e.features[0].properties[map[keys[i]]];
				}
				PopupStore.actions.custom(props, e.lngLat, true);
			}
		},
		onLeavePoint: () => {
			PopupStore.actions.custom({}, null, false);
		},
		getLoadedLayers: () => {
			const results = [];
			if (get(UKHOWindStore.meta.layerData.ukho_oag_surfaces.loadState) === LoadState.LOADED) {
				results.push("ukho_oag_surfaces");
			}
			if (get(UKHOWindStore.meta.layerData.ukho_oag_platforms.loadState) === LoadState.LOADED) {
				results.push("ukho_oag_platforms");
			}
			if (get(UKHOWindStore.meta.layerData.ukho_cables.loadState) === LoadState.LOADED) {
				results.push("ukho_cables");
			}
			if (get(UKHOWindStore.meta.layerData.ukho_structures.loadState) === LoadState.LOADED) {
				results.push("ukho_structures");
			}
			return results;
		}
	}
};

export default UKHOWindStore;
